import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';
import { toggleClass } from '@opten/dom/toggle-class';

declare var ScrollMagic: any;
declare var TimelineMax: any;
declare var TweenMax: any;
declare var Linear: any;
const scrollMagicController = new ScrollMagic.Controller();

@Component({ className: 'js-magic-scroll' })
export class MagicScrollComponent {
	constructor(private triggerElement: HTMLElement) {
		const scene = this.triggerElement.getAttribute('data-magic-scene');
		if (scene != null) {
			switch (scene.toUpperCase()) {
				case 'CLASSTOGGLE':
					this.initSceneClassToggle();
					break;
				case 'NAVIGATIONCLASSTOGGLE':
					this.initSceneNavigationClassToggle();
					break;
				case 'STICKYCOLUMN':
					this.initSceneStickyColumn();
					break;
				case 'ADVENTCALENDAR':
					this.initSceneAdventCalendar();
				default:
					break;
			}
		}
	}
	private initSceneAdventCalendar() {
		let scene = this.createAdventCalendarScrollMagic();
		let windowWidth = window.outerWidth;
		window.addEventListener(
			'resize',
			debounce(() => {
				if (
					windowWidth > window.outerWidth ||
					windowWidth < window.outerWidth
				) {
					scene.destroy(true);
					scene = this.createAdventCalendarScrollMagic();
				}
			}, 100)
		);
	}

	private createAdventCalendarScrollMagic() {
		const svgElement = this.triggerElement.querySelector('svg');
		var box = svgElement.viewBox.baseVal;
		const middleLayerElement = svgElement.querySelector('#middle-layer');
		const carElement = svgElement.querySelector('#mercedes');
		const frontWheeElement = svgElement.querySelector('#front-wheel');
		const rearWheeElement = svgElement.querySelector('#rear-wheel');
		const wheelRotationSpeed = '7200';

		const foregroundElement = svgElement.querySelector('#foreground');
		const bounds = svgElement.getBoundingClientRect();
		//let xTranslation =	box.width - window.innerWidth - (bounds.width > box.width ? bounds.width - box.width : 0);
		//let xTranslation =	box.width - (window.innerWidth * (bounds.width / box.width));
		let xTranslation = box.width / 2;

		let triggerElementBox = this.triggerElement.getBoundingClientRect();
		let carTranslationX = 0;
		const carBounds = carElement.getBoundingClientRect();
		if (carBounds.x + carBounds.width > window.outerWidth) {
			carTranslationX = window.outerWidth - carBounds.width;
		}
		const carTranslationXFinal =
			carTranslationX > 0 ? -50 : carTranslationX == 0 ? 0 : '-50%';
		var tween = new TimelineMax().add([
			TweenMax.set(carElement, { x: carTranslationXFinal }),
			TweenMax.to(middleLayerElement, 1, {
				x: -xTranslation * 0.65,
				ease: Linear.easeNone
			}),
			TweenMax.to(foregroundElement, 1, {
				x: -xTranslation * 1.5,
				ease: Linear.easeNone
			}),
			TweenMax.to(frontWheeElement, 1, {
				rotation: wheelRotationSpeed,
				transformOrigin: '50% 50%'
			}),
			TweenMax.to(rearWheeElement, 1, {
				rotation: wheelRotationSpeed,
				transformOrigin: '50% 50%'
			})
		]);

		const headerElement = document.getElementsByClassName('js-header')[0];
		const headerHeight = Math.round(
			headerElement.getBoundingClientRect().height
		);


		// build scene
		return (
			new ScrollMagic.Scene({
				triggerElement: this.triggerElement,
				duration: bounds.width,
				offset: -headerHeight,
				triggerHook: 0
			})
				.setTween(tween)
				.setPin(this.triggerElement)
				//.addIndicators() // add indicators (requires plugin)
				.addTo(scrollMagicController)
				.on('update', e => {
					this.triggerElement.setAttribute(
						'data-direction',
						e.target.controller().info('scrollDirection')
					);
				})
		);
	}

	private initSceneStickyColumn() {
		const targetElements = Array.from(
			this.triggerElement.querySelectorAll<HTMLElement>(
				'.js-magic-scroll-target'
			)
		);
		const minWidthSticky = 1230;
		let smallerElement: HTMLElement;
		let smallestHeight = 5000;
		for (const element of targetElements) {
			const bounds = element.getBoundingClientRect();
			if (bounds.height < smallestHeight) {
				smallestHeight = bounds.height;
				smallerElement = element;
			}
		}

		const triggerBounds = this.triggerElement.getBoundingClientRect();
		const style = getComputedStyle(smallerElement.firstElementChild);
		const height =
			smallerElement.offsetHeight +
			parseInt(style.marginTop, 10) +
			parseInt(style.marginBottom, 10);

		const headerElement = document.getElementsByClassName('js-header')[0];
		const headerHeight = Math.round(
			headerElement.getBoundingClientRect().height
		);

		const scene = new ScrollMagic.Scene({
			triggerElement: this.triggerElement,
			offset: -headerHeight,
			triggerHook: 0,
			duration: triggerBounds.height - height
		})
			.setPin(smallerElement)
			.addTo(scrollMagicController);
		if (window.innerWidth < minWidthSticky) {
			scene.enabled(false);
			for (const element of targetElements) {
				element.parentElement.removeAttribute('style');
			}
		}

		window.addEventListener(
			'resize',
			debounce(() => {
				if (window.innerWidth < minWidthSticky) {
					scene.enabled(false);
					for (const element of targetElements) {
						element.parentElement.removeAttribute('style');
					}
				} else {
					scene.enabled(true);
				}
			}, 300)
		);
	}

	private initSceneClassToggle() {
		const classToToggle =
			this.triggerElement.getAttribute('data-magic-class-toggle') ||
			'is-animating';
		const triggerHook =
			this.triggerElement.getAttribute('data-magic-trigger-hook') ||
			'0.9';
		const offset =
			this.triggerElement.getAttribute('data-magic-offset') || '0';

		if (
			this.triggerElement.classList.contains('js-timeline-line-item') ==
			false
		) {
			new ScrollMagic.Scene({
				triggerElement: this.triggerElement,
				triggerHook: parseFloat(triggerHook),
				offset
			})
				.setClassToggle(this.triggerElement, classToToggle)
				.addTo(scrollMagicController);
		} else {
			new ScrollMagic.Scene({
				triggerElement: this.triggerElement,
				duration: window.outerHeight - 400,
				offset
			})
				.setClassToggle(this.triggerElement, classToToggle)
				.addTo(scrollMagicController);
		}
	}

	private initSceneNavigationClassToggle() {
		const targetElements = Array.from(
			this.triggerElement.querySelectorAll<HTMLElement>(
				'.js-magic-scroll-navigation-target'
			)
		);
		const minWidthSticky = 1230;

		targetElements.forEach(target => {
			const targetId = target.getAttribute('data-target-navigation-id');
			const targetIdElement = document.getElementById(targetId);
			let scene = new ScrollMagic.Scene({
				triggerElement: targetIdElement,
				duration: targetIdElement.getBoundingClientRect().height
			})
				.setClassToggle(target, '--active')
				.addIndicators()
				.addTo(scrollMagicController);

			window.addEventListener(
				'resize',
				debounce(() => {
					if (window.innerWidth < minWidthSticky) {
						scene.enabled(false);
					} else {
						scene.destroy(true);
						scene = new ScrollMagic.Scene({
							triggerElement: targetIdElement,
							duration:
								targetIdElement.getBoundingClientRect().height
						})
							.setClassToggle(target, '--active')
							// .addIndicators()
							.addTo(scrollMagicController);
					}
				}, 300)
			);
		});
	}
}
